module.exports = __webpack_public_path__ + "assets/chevron-right-small-4bf2ba.svg";